import { gql } from '@apollo/client';

const UPDATE_TO_BAG_MUTATION = gql`
mutation updateToBagRequest($shortSku: String! $orderItemId: String!) {
  updateToBagRequest(shortSku: $shortSku, orderItemId: $orderItemId ) {
    success
    responseData {
      cartUnitsAdded
      orderSubtotal
      orderSubtotalUsd
      freeShippingThreshold {
        freeShippingThreshold
        freeShippingThresholdFmt
        minShippingThreshold
        minShippingThresholdFmt
      }
      amountToFreeShipping
      amountToFreeShippingFmt
      pageType
    }
    errors {
      message {
          key
          value
      }
      status
    }
  }
}
`;

export default UPDATE_TO_BAG_MUTATION;
